import React, {
  createContext,
  useContext,
} from "react";


const PlatformLayoutContext =
  createContext(
    null
  );


export const PlatformLayoutProvider =
  PlatformLayoutContext.Provider;


export const usePlatformLayout =
  () => {

    const context =
      useContext(
        PlatformLayoutContext
      );


    if (
      !context
    ) {

      throw new Error(
        "usePlatformLayout must be used inside PlatformAuthGuard."
      );

    }


    return context;

  };